import "@shoelace-style/shoelace/dist/components/icon-button/icon-button.js";

import { css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html } from "lit/static-html.js";
import { Style } from "./Styles";

@customElement("ds-copy-to-clipboard")
export class CopyToClipboard extends LitElement {
    static override styles = [
        Style,
        css`
            .container {
                color: inherit;
            }

            sl-icon-button {
                color: inherit;
            }

            sl-icon-button::part(base) {
                padding: 0;
            }
        `,
    ];
    @property({ type: String }) text: any;

    override render() {
        return html` <span class="container">
            <sl-icon-button
                label="Copy to clipboard"
                name="files"
                @click=${() => {
                    navigator.clipboard.writeText(this.text);
                }}
            >
            </sl-icon-button
        ></span>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-copy-to-clipboard": CopyToClipboard;
    }
}
